class DeliveryTime extends HTMLElement {
    constructor() {
        super();
        this.formatString = this.getAttribute("data-frm-day") || "";
        this.excludedDays = (this.getAttribute("data-exclude-day") || '')
            .replace(/ /g, '')
            .split(",")
            .filter(Boolean);
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.targetTime = this.getAttribute("data-time") || "17:00:00";
        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');
        this.iso_code = document.documentElement.lang;
        this.checkExclude = this.checkAllExcludeDays(this.excludedDays);
        if (this.checkExclude) return;
        this.productDeliveryTime();
        const updateCountdown = () => {
            const countdown = this.countdownToTime(this.targetTime);
            if (this.hr) this.hr.innerHTML = countdown.hours;
            if (this.mins) this.mins.innerHTML = countdown.minutes;
        };
        updateCountdown();
        this.style.display = "block";
        setInterval(updateCountdown, 1000);
    }
    checkAllExcludeDays(excludedDays) {
        const now = new Date();
        const deliveryDateTime = new Date(now);
        for (let day of excludedDays) {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) return true;
        }
        return false;
    }
    // Vorher: nutzte jQuery ($) um [data-delivery-time] im ganzen Dokument zu suchen.
    // Fix: greift direkt auf die eigenen Kind-Elemente zu (this = <delivery-time>-Element
    // selbst) - keine externe Abhängigkeit mehr, kann nicht mehr an fehlendem/verspätet
    // geladenem jQuery scheitern.
    productDeliveryTime() {
        const startEl = this.querySelector('[data-start-delivery]');
        const endEl = this.querySelector('[data-end-delivery]');
        if (!startEl && !endEl) return;
        let startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
        let endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);
        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);
        if (startEl) startEl.innerHTML = formattedStartDate;
        if (endEl) endEl.innerHTML = formattedEndDate;
    }
    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = this.iso_code || 'de-DE';
        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });
        return formatString
            .replaceAll('DD', dayOfMonth)
            .replaceAll('MMM', month)
            .replaceAll('MM', monthNumber)
            .replaceAll('YYYY', year)
            .replaceAll('d', dayOfWeek);
    }
    excludeDays(excludedDays, dataRange) {
        const now = new Date(),
            deliveryDateTime = new Date(now);
        deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange, 10));
        // Verschiebt weiter, solange das Datum auf einen ausgeschlossenen Tag fällt
        // (funktioniert auch bei aufeinanderfolgenden Tagen, z.B. Sa + So)
        let shifted = true;
        while (shifted) {
            shifted = false;
            for (let day of excludedDays) {
                const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
                if (deliveryDateTime.getDay() === dayIndex) {
                    deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
                    shifted = true;
                }
            }
        }
        // ISO-Format (YYYY-MM-DD) lässt sich zuverlässig über alle Locales/Browser parsen
        const y = deliveryDateTime.getFullYear();
        const m = String(deliveryDateTime.getMonth() + 1).padStart(2, '0');
        const d = String(deliveryDateTime.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
    countdownToTime(targetTime) {
        if (!targetTime || targetTime.trim() === '') return { hours: '--', minutes: '--' };
        const currentTime = new Date(),
            targetTimeString = `${currentTime.toDateString()} ${targetTime}`,
            targetDateTime = new Date(targetTimeString);
        if (isNaN(targetDateTime.getTime())) return { hours: '--', minutes: '--' };
        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);
        const remainingTime = targetDateTime - currentTime;
        return {
            hours: Math.floor(remainingTime / (1000 * 60 * 60)),
            minutes: Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
        };
    }
}
customElements.define('delivery-time', DeliveryTime);